import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { FaChevronRight, FaFire } from 'react-icons/fa'

// Bütün public client səhifələri üçün vahid həftəlik fürsətlər keçidi.
// Dashboard, auth və checkout marşrutlarında göstərilmir.
// Desktop: kompakt pill; mobil: bottom navigation-dan yuxarı flame dairəsi.
const HIDDEN_PREFIXES = ['/login', '/register', '/forgot-password', '/oauth-success', '/shipping', '/payment', '/dashboard', '/admin/dashboard', '/seller/dashboard']

const WeeklyDealsGateway = () => {
  const { pathname } = useLocation()
  if (HIDDEN_PREFIXES.some(prefix => pathname === prefix || pathname.startsWith(`${prefix}/`))) return null

  return (
    <div
      className='fixed bottom-5 left-5 z-40 md:bottom-[88px] md:left-3'
      style={{ marginBottom: 'env(safe-area-inset-bottom, 0px)' }}
    >
      <Link
        to='/haftanin-firsatlari'
        aria-label='Həftənin Fürsətlərinə keç'
        className='group relative flex items-center rounded-full border border-orange-300/70 bg-slate-950/95 p-1.5 pr-4 text-white shadow-[0_10px_34px_rgba(234,88,12,0.30)] backdrop-blur-md transition duration-200 hover:-translate-y-0.5 hover:border-orange-200 hover:shadow-[0_14px_40px_rgba(234,88,12,0.42)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange-500 md:h-12 md:w-12 md:justify-center md:p-1.5 md:hover:w-12'
      >
        <span className='weekly-deals-float__flame relative flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-yellow-400 via-orange-500 to-red-600 text-base text-white shadow-[0_0_18px_rgba(249,115,22,0.55)]'>
          <FaFire />
        </span>

        <span className='pl-2.5 md:hidden'>
          <span className='block whitespace-nowrap text-[13px] font-extrabold leading-tight tracking-tight text-white'>
            Həftənin Fürsətləri
          </span>
          <span className='flex items-center gap-1 whitespace-nowrap text-[10px] font-semibold leading-4 text-orange-200'>
            Fürsətlərə bax
            <FaChevronRight size={8} />
          </span>
        </span>
      </Link>
    </div>
  )
}

export default WeeklyDealsGateway
